import { AccountStore } from './account.store';

export const stores = [AccountStore];

export { AccountStore };
